<div class="container-fluid">
    <div class="row">

        <div class="col-md-4 mt-4 p-4">
            <mat-card class="uploadxls p-2">
                <mat-card-header>
                    <mat-card-title>Forgot Password?</mat-card-title>
                </mat-card-header>
                <form id="uploadxl" class="example-form" [formGroup]="forgotPass">
                    <mat-card-content>

                        <mat-form-field class="example-full-width width-50">
                            <input [(ngModel)]="password_email" matInput placeholder="Please enter email address"
                                formControlName="emailpass">
                        </mat-form-field>

                        <mat-card *ngIf="tempPass">Temprory password has been sent to your email id : {{ password_email
                            }}</mat-card>
                    </mat-card-content>
                    <mat-card-actions>
                        <button [routerLink]="['']" class="backTop mr-4" mat-raised-button
                            color="default">Cancel</button>

                        <button [disabled]="!forgotPass.valid" type="button" mat-raised-button color="primary">Send
                            Password</button>
                    </mat-card-actions>
                </form>
            </mat-card>
        </div>
    </div>
</div>